const pressPage = (ScrollTrigger, Swiper, Navigation) => {
	
	const pressCarousel = document.querySelector('.featured-news-content.swiper');
	
	if (pressCarousel) {
		// Calculate spacing based on viewport width (8.5% of viewport)
		const calculateSpacing = () => {
			return Math.round(window.innerWidth * 0.085);
		};
		
		const pressCarouselSwiper = new Swiper(pressCarousel, {
			modules: [Navigation],
			slidesPerView: 1,
			spaceBetween: calculateSpacing(),
			loop: true,
			loopedSlides: 3,
			watchSlidesProgress: true,
			updateAutoHeight: true,
			navigation: {
				nextEl: '.press-button-next',
				prevEl: '.press-button-prev',
			},
			on: {
				init: function() {
					this.updateAutoHeight();
				},
				slideChange: function() {
					this.updateAutoHeight();
					ScrollTrigger.refresh();
				}
			}
		});

		// Update spacing on window resize
		let resizeTimeout;
		window.addEventListener('resize', () => {
			clearTimeout(resizeTimeout);
			resizeTimeout = setTimeout(() => {
				pressCarouselSwiper.params.spaceBetween = calculateSpacing();
				pressCarouselSwiper.update();
				pressCarouselSwiper.updateAutoHeight();
			}, 250);
		});
	}
	
}

export {
	pressPage
};